<template>
  <v-container class="fill-height justify-center">
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          <v-row class="justify-space-between align-center">
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" :to="'/coa'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="primary">mdi-file-cog</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    CoA
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/set-saldo-awal'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="red">mdi-currency-usd</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Set Saldo Awal
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/jurnal'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="warning">mdi-file-document-edit-outline</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Jurnal
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/buku-besar'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                <!-- <v-card min-width="180" class="rounded-lg" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }"> -->
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="success">mdi-book-open-blank-variant</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Buku Besar
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/neraca'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="accent">mdi-scale-balance</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2"> Neraca </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/laba-rugi'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                    <v-icon size="100" color="pink">mdi-chart-bell-curve-cumulative</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laba Rugi
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/trial-balance'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                    <v-icon size="100" color="#3E2723">mdi-book-remove</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Tutup Buku
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/audit'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                    <v-icon size="100" color="#00838F">mdi-list-box</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Audit
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            
            <!-- <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/ake/music'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="#D400B8">mdi-cellphone</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    AKE
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
  },

  mounted() {
    this.fetchDetail();
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
    async fetchDetail () {
      await get(`account/data`)
      .then(response => {
        let res = response.data

        // this.process.load = false
          
        if (res.status === 200) {
          // this.form = res.results.data
        }
      })
    },
  },
};
</script>

<style>
</style>